import React from 'react';
import Box from '../../components/Layout/Wrappers/Box';
import Subtitle from '../../components/Layout/Wrappers/Subtitle';
import AppUI from '../../dictionaries/AppUI.dic';
import Core from '../Core';
import Typography from '../../components/Layout/Wrappers/Typography';

export default function globalErrorHandler(error) {
  if (Core.isProduction()) {
    Core.showError(AppUI.errorMessage.unexpected, error);
  }
  else {
    Core.showError(
      <Box column>
        <Subtitle className='c-white-medium'>
          The following message is only visible in development and must be addressed before going to production
        </Subtitle>
        <Box>
          {React.isValidElement(error) ? error : error?.toString()}
        </Box>
        <Subtitle className='c-white-medium'>
          Production message:
        </Subtitle>
        <Typography className='f-sm'>
          {AppUI.errorMessage.unexpected}
        </Typography>
      </Box>,
      error
    );
  }
}
